var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGalleryBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 16V8.5C1.5 7.6715 2.1715 7 3 7H17.5C18.3285 7 19 7.6715 19 8.5V16M18.8925 20.059C18.6705 20.6105 18.131 21 17.5 21H3C2.1715 21 1.5 20.3285 1.5 19.5V19.02L5.8325 14.294C6.1915 13.9025 6.809 13.9025 7.168 14.294L11.482 19M4.5 5C4.5 4.4475 4.9475 4 5.5 4H20C21.1045 4 22 4.8955 22 6V17C22 17.8285 21.3285 18.5 20.5 18.5H20.235C19.752 18.5 19.276 18.3835 18.848 18.16L14.1885 15.7305C13.574 15.41 12.837 15.4305 12.2415 15.785L9.95 17.1485M16 11C16 11.8284 15.3284 12.5 14.5 12.5C13.6716 12.5 13 11.8284 13 11C13 10.1716 13.6716 9.5 14.5 9.5C15.3284 9.5 16 10.1716 16 11Z",
    stroke: "#3545DE",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryBlue);
export default __webpack_public_path__ + "static/media/galleryBlue.c7ade3e7942de27cd17e7a95c49552a6.svg";
export { ForwardRef as ReactComponent };